/**
 * Standard Mode Strategy
 *
 * Display mode strategy for the default centered popup.
 * This is the classic popup that appears centered on screen with a backdrop.
 */

import type { DisplayConfig } from '../../shared/types/popup';
import type { DisplayModeStrategy } from './types';

/**
 * Strategy for standard centered popup display mode.
 */
export class StandardModeStrategy implements DisplayModeStrategy {
	/**
	 * Returns CSS classes for standard popup mode.
	 */
	public getDisplayModeClasses = (): string[] => {
		return ['gp-popup--popup'];
	};

	/**
	 * Apply body scroll lock when popup opens.
	 */
	public applyBodyState = (): void => {
		document.body.classList.add('gp-popup-open');
	};

	/**
	 * Remove body scroll lock when popup closes.
	 * Only removes if no other popups are open.
	 */
	public removeBodyState = (): void => {
		// Only remove gp-popup-open if no other popups are open
		if (!document.querySelector('.gp-popup--open')) {
			document.body.classList.remove('gp-popup-open');
		}
	};

	/**
	 * Apply custom sizing to the dialog.
	 * Standard popups support width/height customization.
	 */
	public applyDialogSizing = (
		dialog: HTMLElement,
		config: DisplayConfig
	): void => {
		dialog.style.width = config.popupWidth;
		dialog.style.height = config.popupHeight;
	};

	/**
	 * Standard popups respect the closeOnBackdropClick config.
	 */
	public shouldCloseOnBackdropClick = (config: DisplayConfig): boolean => {
		return config.closeOnBackdropClick;
	};
}
